export default __webpack_public_path__ + "images/0xc25351811983818c9fe6d8c580531819c8ade90f.png";